module.exports = __webpack_public_path__ + "media/icons/switch-vertical-615ebe36.svg";